import actions from "./actions";

const { FETCH_MONTH_DECLARATION, FETCH_MONTH_DECLARATIONS, RESET_MONTH_DECLARATION } = actions;

const initState = {
    monthDeclarations: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    monthDeclaration: { _id: null }
};

const MonthDeclarationReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_MONTH_DECLARATIONS:
            return {
                ...state,
                monthDeclarations: data
            };
        case RESET_MONTH_DECLARATION:
            return {
                ...state,
                monthDeclaration: initState.monthDeclaration
            };
        case FETCH_MONTH_DECLARATION:
            return {
                ...state,
                monthDeclaration: data
            };
        default:
            return state;
    }
};

export default MonthDeclarationReducer;
